// @flow
import React from 'react';
import styled from '@emotion/styled';

import SalaryStatus from 'app/components/challenge/SalaryStatus';
import Button from 'app/components/commons/Button';
import Checkbox from 'app/components/commons/Checkbox';

import LineUpTable from './LineUpTable';

type Props = {
  numSelected: number,
  salaryCap: number,
  salaryExpenditure: number,
  requiredSelections: number,
  positions: Array<Object>,
  keepCurrentLineUps: boolean,
  isCrunching: boolean,
  onSelectSettingsTab: (tab: string) => void,
  onSwitchSelectedPosition: () => void,
  onToggleKeepCurrentLineUps: () => void,
  onRemove: () => void,
  onSubmitAll: () => void,
  onSubmit: () => void
};

const defaultProps = {
  // salaryCap: undefined
};

const Wrapper = styled.div(({ theme }) => ({
  paddingRight: theme.spacing.tiny
}));

const Note = styled.p(({ theme }) => ({
  marginTop: theme.spacing.small
}));

const Title = styled.h3(({ theme }) => ({
  [theme.mediaQuery.tabletPortraitAndBelow]: {
    paddingLeft: theme.spacing.tiny
  },
  fontSize: '1.11rem',
  textTransform: 'uppercase',
  margin: '1rem 0'
}));

const BottomWrapper = styled.div(({ theme }) => ({
  [theme.mediaQuery.tabletPortraitAndBelow]: {
    padding: theme.spacing.tiny
  }
}));

const LineUp = ({
  numSelected,
  salaryCap,
  keepCurrentLineUps,
  salaryExpenditure,
  onSwitchSelectedPosition,
  onSelectSettingsTab,
  onToggleKeepCurrentLineUps,
  onRemove,
  isCrunching,
  positions,
  requiredSelections,
  onSubmitAll,
  onSubmit
}: Props) => {
  const remainingSelections = requiredSelections - numSelected;
  // numSelected === requiredSelections &&
  // positions.every(p => p.filled && !p.hasError) &&
  // salaryExpenditure <= salaryCap;

  return (
    <Wrapper>
      <Title>Locked Lineup</Title>
      <LineUpTable
        remainingSelections={remainingSelections}
        positions={positions}
        onSelectSettingsTab={onSelectSettingsTab}
        onSwitchSelectedPosition={onSwitchSelectedPosition}
        onRemove={onRemove}
      />
      <SalaryStatus
        noTopRadius
        showUtilisation={false}
        currentStep={numSelected}
        salaryCap={salaryCap}
        salaryExpenditure={salaryExpenditure}
        totalSteps={requiredSelections}
      />
      <Button
        autoBorderRadius={false}
        block
        kind="primary"
        disabled={isCrunching}
        onClick={onSubmitAll}
      >
        Crunch Lineups From All
      </Button>
      <Button autoBorderRadius={false} block kind="info" disabled={isCrunching} onClick={onSubmit}>
        Crunch Lineups From ShortList
      </Button>
      <BottomWrapper>
        <Checkbox checked={keepCurrentLineUps} onChange={onToggleKeepCurrentLineUps}>
          KEEP CURRENT LINEUPS
        </Checkbox>
        <Note>
          The default exposure portfolio method for single game slates is &quot;reduce included
          players by 1%&quot;. The default exposure portfolio method for multiple game slates is
          &quot;unique players and max exposure&quot;. Use the exposure tab in settings to change
          the portfolio method to crunch mass lineups.
        </Note>
      </BottomWrapper>
    </Wrapper>
  );
};

LineUp.defaultProps = defaultProps;

export default React.memo(LineUp);
